import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import awsConfig from './config/aws-config';

import SignUp from './components/SignUp';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard';
import RequestsPage from './components/RequestsPage';
import VoiceRecorder from './components/VoiceRecorder';
import ChannelManagement from './components/ChannelManagement';
import ProjectManagement from './components/ProjectManagement';
import AuthRoute from './components/AuthRoute';
import { BUILD_INFO } from './config/buildInfo';

// Amplify 설정 초기화
Amplify.configure(awsConfig);

// 404 페이지 컴포넌트
const NotFound = () => (
  <div className="not-found">
    <h2>페이지를 찾을 수 없습니다</h2>
    <p>요청하신 페이지가 존재하지 않습니다.</p>
    <Link to="/">홈으로 돌아가기</Link>
  </div>
);

// 홈 리다이렉트 컴포넌트
const HomeRedirect = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  if (isLoading) {
    return <div className="loading">인증 상태를 확인 중입니다...</div>;
  }

  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Navigate to="/signin" replace />;
};

const App = () => {
  return (
    <Router basename="/">
      <div className="app-container">
        <header>
          <h1>Aigent</h1>
          <nav>
            <ul className="nav-links">
              <li><Link to="/dashboard">대시보드</Link></li>
              <li><Link to="/requests">Tasks</Link></li>
              <li><Link to="/voice">음성 녹음</Link></li>
              <li><Link to="/channels">채널 관리</Link></li>
              <li><Link to="/projects">프로젝트 관리</Link></li>
            </ul>
          </nav>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/signin" element={<SignIn />} />
            <Route element={<AuthRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/requests" element={<RequestsPage />} />
              <Route path="/voice" element={<VoiceRecorder />} />
              <Route path="/channels" element={<ChannelManagement />} />
              <Route path="/projects" element={<ProjectManagement />} />
            </Route>
            {/* 404 페이지 처리 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <footer className="build-info">
          <small>{BUILD_INFO.buildTime}</small>
        </footer>
      </div>
    </Router>
  );
};

export default App;
